export const LayoutConfig = {
    menuItems: [
        {
            title: 'Administration',
            menuItems: [
                { item: 'Account mapping administration', href: '/LST/AdminPages/AccountMapping' },
                { item: 'Report mapping administration', href: '/LST/AdminPages/ReportMapping' },
                { item: 'Node administration', href: '/LST/AdminPages/Nodes' },
                { item: 'Global scenario administration', href: '/LST/AdminPages/GlobalScenario' },
                { item: 'Report user administration', href: '/LST/AdminPages/ReportUsers' },
                { item: 'Report process log', href: '/LST/AdminPages/ReportProcessLog' },
            ]
        },
        {
            title: 'Data',
            menuItems: [
                { item: 'Scenarios', href: '/LST/Data/Scenarios' },
                { item: 'Upload scenarios', href: '/LST/Data/UploadScenarios' },
                { item: 'Data corrections', href: '/LST/Data/DataCorrections' },
                { item: 'Upload corrections', href: '/LST/Data/UploadCorrections' },
                { item: 'Mitigations', href: '/LST/Data/Mitigations' },
                { item: 'Upload mitigations', href: '/LST/Data/UploadMitigations' },
                { item: 'Results and comments', href: '/LST/Data/ResultsAndComments' },
                { item: 'Reporting structure', href: '/LST/Data/ReportingStructure' },
                { item: 'Upload global scenarios', href: '/LST/Data/UploadGlobalScenarios' },
                { item: 'Upload report mapping', href: '/LST/Data/UploadReportMapping' },
                { item: 'Upload account mapping', href: '/LST/Data/UploadAccountMapping' },
            ]
        },
        {
            title: 'Reports',
            menuItems: [
                { item: 'LSP profile', href: '/LST/Reports/LSPProfile' },
                { item: 'Export LSP profile', href: '/LST/Reports/LSPProfileExport' },
                { item: 'DNB profile', href: '/LST/Reports/DNBProfile' },
                { item: 'Account calculation', href: '/LST/Reports/AccountCalculation' },
                { item: 'LST overview', href: '/LST/Reports/LSTOverview' },
                { item: 'Node overview', href: '/LST/Reports/NodeOverview' },
                { item: 'Tagetik 5028', href: '/LST/Reports/Tagetik5028' },
            ]
        },
    ]
}